import { render, staticRenderFns } from "./AddTeachingField.vue?vue&type=template&id=1dcd52e8&scoped=true&"
import script from "./AddTeachingField.vue?vue&type=script&lang=js&"
export * from "./AddTeachingField.vue?vue&type=script&lang=js&"
import style0 from "./AddTeachingField.vue?vue&type=style&index=0&id=1dcd52e8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd52e8",
  null
  
)

export default component.exports